import { cn } from "@/lib/utils";
import {
  Scissors, Sparkles, Hand, Flower, Palette, BrickWall, Zap, Wrench,
  PaintRoller, Hammer, Stethoscope, Home, Dog, Utensils, Coffee, Wine,
  ChefHat, Sprout, Trees, Droplets, Mountain, Store, Tractor, ClipboardList,
  Leaf, Layout, TrendingUp, Server, ShieldCheck, Tag, Loader2,
} from "lucide-react";

const ICONS = {
  scissors: Scissors, sparkles: Sparkles, hand: Hand, flower: Flower, palette: Palette,
  "brick-wall": BrickWall, zap: Zap, wrench: Wrench, "paint-roller": PaintRoller, hammer: Hammer,
  stethoscope: Stethoscope, home: Home, dog: Dog, utensils: Utensils, coffee: Coffee, wine: Wine,
  "chef-hat": ChefHat, sprout: Sprout, trees: Trees, droplets: Droplets, mountain: Mountain,
  store: Store, tractor: Tractor, "clipboard-list": ClipboardList, leaf: Leaf, layout: Layout,
  "trending-up": TrendingUp, server: Server, "shield-check": ShieldCheck,
};

export function CategoryIcon({ name, className }) {
  const Ico = ICONS[name] || Tag;
  return <Ico className={className} />;
}

export function Btn({ variant = "primary", className, style, ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 font-medium text-sm px-5 h-11 transition-all duration-200 disabled:opacity-50 disabled:pointer-events-none active:scale-[.98] whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-[var(--bg)]";
  const filled = ["primary", "accent", "danger", "soft"].includes(variant);
  const variants = {
    primary: { background: "var(--primary)", color: "var(--primary-fg)", boxShadow: "var(--shadow-sm)" },
    accent: { background: "var(--accent)", color: "var(--accent-fg)", boxShadow: "var(--shadow-sm)" },
    outline: { background: "transparent", color: "var(--text)", border: "1px solid var(--border)" },
    ghost: { background: "transparent", color: "var(--text)" },
    soft: { background: "var(--surface-alt)", color: "var(--text)" },
    danger: { background: "var(--danger)", color: "#fff", boxShadow: "var(--shadow-sm)" },
  };
  return (
    <button
      className={cn(base, filled && "hover:shadow-md", className)}
      style={{ borderRadius: "var(--radius)", ...variants[variant], ...style }}
      {...props}
    />
  );
}

export function Card({ className, style, ...props }) {
  return (
    <div
      className={cn("border", className)}
      style={{
        background: "var(--surface)",
        borderColor: "var(--border)",
        borderRadius: "var(--radius)",
        boxShadow: "var(--shadow-sm)",
        ...style,
      }}
      {...props}
    />
  );
}

export function Loader({ label }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24 kw-fade" style={{ color: "var(--text-muted)" }}>
      <Loader2 className="h-7 w-7 animate-spin" style={{ color: "var(--accent)" }} />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}
